import React, { useEffect, useRef, useState } from "react";

import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { MdMoveUp } from "react-icons/md";

import "../Asociados/asociadosTable.css";

import styles from "./../tooltip.module.css";

import { buildName, Singleton } from "helper/tools";
import SkeletonTable from "../Skeleton/SkeletonTable";
import {
  handleEstadoBodega,
  handleOrdenVentaEstados,
  handleOrdenVentaStatus,
  handleTipoEntrega,
  hasDatePassedXDays,
  //  ORDEN_VENTA_ESTADOS,
  ORDEN_VENTA_STATUS,
} from "../../helperFunctions/helpers";
import { format, parseJSON } from "date-fns";

import ticketVenta from "./utils/ticketVenta";
import ComboButton from "../ComboButton";
import {
  EstadoBodega,
  TipoEntrega,
  EstadoOrden,
} from "../../../../helper/const";
import ConfigForaneo from "./ConfigForaneo";
import CancelOrdenVentaModal from "../Productos/CancelOrdenVentaModal";
import DevolucionOrdenVentaModal from "../Productos/DevolucionOrdenVentaModal";

import ticketVentaNew from "./utils/ticketNew";

import * as api from "helper/helper";
import toast from "react-hot-toast";
import NumeroALetras from "./utils/NumerosALetras";
import { useAuthStore } from "../../../../store/store";
import { PermissionsForSection } from "../auth";
import { Sections } from "components/proto/data/navItem";

/**
 *
 * @param {*} param0
 * @returns
 */

export default function VentasTable({
  items,
  openItem,
  handleSortChange,
  changeBodegaStatus,
  changeEstadoOrden,
  changeEstatuOrden,
  reloadOrdenes,
  isLoading = false,
  skeletonItemCount = 5,
}) {
  const theadRef = useRef();
  const createProductoRef = useRef();

  const cancelOrdenVentaRef = useRef();
  const devolucionOrdenRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [modalDataCancel, setModalDataCancel] = useState(null);
  const [modalDataDevolucion, setModalDataDevolucion] = useState(null);
  const [base64, setBase64] = useState("");
  const [message, setMessage] = useState("");

  const [base64a, setBase64a] = useState("");
  const [messagea, setMessagea] = useState("");

  const isAdmin = useAuthStore((state) => state.isAdmin);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  useEffect(() => {
    const newPermissions = PermissionsForSection(Sections.Ventas);
    setPermissions(newPermissions);
  }, []);

  const onGenerateTicketNew = async (output) => {
    setBase64("");
    setMessage("");

    const response = await ticketVentaNew(output);

    if (!response?.success) {
      alert(response?.message);
      return;
    }

    if (output === "b64") {
      setBase64(response?.content ?? "");
    }
    setTimeout(() => {
      setMessage(response?.message);

      setTimeout(() => {
        setMessage("");
      }, 2000);
    }, 2000);
  };

  const onGenerateTicket = async (output, item) => {
    setBase64("");
    setMessage("");

    const response = await ticketVenta(output, item);

    if (!response?.success) {
      alert(response?.message);
      return;
    }

    if (output === "b64") {
      setBase64(response?.content ?? "");
    }

    setTimeout(() => {
      setMessage(response?.message);

      setTimeout(() => {
        setMessage("");
      }, 2000);
    }, 2000);
  };

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  async function generatePDF(event, item) {
    console.log("");

    const payload = {
      ordenVentaId: item.id,
    };

    const response = await api.generateTicketPDF(payload).catch((e) => {
      toast.error("Error al generar ticket Orden de Venta.");
    });

    if (!response) {
      toast.error("Error al generar ticket Orden de Venta.");
      return;
    }

    /// name file, fallback random
    const secondsSinceEpoch = Math.floor(Date.now() / 1000);
    let fileName = `OrdenVenta_Ticket_${secondsSinceEpoch}.pdf`;

    const contentDisposition = response.headers["content-disposition"];

    /*if (contentDisposition) {
      const fileNameMatch = contentDisposition
        .matchAll(/filename=(.*?)(;|$)/g)
        .toArray()[0][1];
      fileName = fileNameMatch.replace(/"/g, "");
      console.log("File Name:", fileName);
    }*/

    // 1. Create a URL for the Blob
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // Create a temporary URL for the blob object
    //  const url = window.URL.createObjectURL(blob);

    // To Open in new tab:
    //  window.open(url);

    /*
    https://www.google.com/search?q=web+api+c%23+download+file+and+open&client=firefox-b-d&hs=WgQ&sca_esv=8eb5eb78efc6b1d8&sxsrf=ANbL-n6yfXnM9yY3j1foZcV3t3SaabxSbw%3A1776970046106&ei=PmnqaYubBrfwkPIPiaWB8AY&biw=1426&bih=834&ved=0ahUKEwiLsv-i0YSUAxU3OEQIHYlSAG4Q4dUDCBE&uact=5&oq=web+api+c%23+download+file+and+open&gs_lp=Egxnd3Mtd2l6LXNlcnAiIXdlYiBhcGkgYyMgZG93bmxvYWQgZmlsZSBhbmQgb3BlbjIFECEYoAFIio8BUL8FWJeIAXABeAGQAQCYAc4BoAGKEKoBBTguOS4xuAEDyAEA-AEBmAIToALzEcICChAAGLADGNYEGEfCAgQQIxgnwgIKECMYgAQYJxiKBcICERAuGIAEGLEDGNEDGIMBGMcBwgIIEAAYgAQYsQPCAgoQABiABBhDGIoFwgILEAAYgAQYsQMYgwHCAgsQLhiABBjRAxjHAcICEBAAGIAEGLEDGEMYgwEYigXCAggQLhiABBixA8ICDRAAGIAEGLEDGEMYigXCAgcQABiABBgKwgIWEC4YgAQYsQMY0QMYQxiDARjHARiKBcICBRAAGIAEwgIGEAAYChgewgIEEAAYHsICCRAAGIAEGAoYC8ICBxAjGLECGCfCAgYQABgWGB7CAggQABgWGAoYHsICBRAAGO8FwgIFECEYnwXCAgQQIRgVmAMA4gMFEgExIECIBgGQBgiSBwYyLjE2LjGgB8B0sgcGMS4xNi4xuAfaEcIHCTAuMy42LjguMsgHsgGACAA&sclient=gws-wiz-serp
    */

    // To Download:
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    console.log("---");

    //  kpiData[itemIndex].clientes = response.data.subset;

    //    const newKpiData = JSON.parse(JSON.stringify(kpiData));

    //  setKpiData(newKpiData);
    //  finishCallback();

    // 4. Free up memory
    window.URL.revokeObjectURL(url);
    //document.body.removeChild(a);
  }

  async function printPDF(event, item) {
    //  onGenerateTicket("b64", item);
    //onGenerateTicket("print", item);
    // OLD  onGenerateTicketNew("print");

    let clienteName = buildName(item.cliente);
    const asociadoName = buildName(item.asociado);

    const ordenDate = format(item.fechaOrden, "dd/MM/yy hh:mm a");

    const total = Singleton.getInstance().format(item.totalVenta);
    const subTotal = Singleton.getInstance().format(item.subTotalVenta);
    const descuento = Singleton.getInstance().format(item.descuento);

    const totalLetra = NumeroALetras(item.totalVenta, true);
    /*    const fechaEntregaDate = item.fechaEntrega
          ? format(item.fechaEntrega, "dd/MM/yy hh:mm a")
          : "-";
        */

    const detalles = item.ordenVentaDetalles
      .map(function (info) {
        let paqProds = info.paquete?.productos.map((paqProd) => {
          let prod = paqProd.producto;
          return {
            cantidad: paqProd.cantidad.toString(),
            name: prod.nombre,
            precioUnitario: Singleton.getInstance().format(paqProd.precio),
            precioTotal: Singleton.getInstance().format(
              paqProd.precio * paqProd.cantidad,
            ),
          };
        });

        return {
          cantidad: info.cantidad.toString(),
          name:
            info.paquete != null ? info.paquete.nombre : info.producto.nombre,
          precioUnitario: Singleton.getInstance().format(info.precio),
          precioTotal: Singleton.getInstance().format(info.total),
          productosEnPaquete: paqProds,
        };
      })
      .flatMap((info) => info);

    let direcciones = item?.asociado?.direcciones;
    if (item?.cliente != null) {
      direcciones = item?.cliente?.direcciones;
    }

    let domicilio = "";
    if (direcciones?.length > 0) {
      const address = direcciones[0];
      const infos = [
        address.calle,
        address.noExterior,
        address.colonia,
        address.cp,
        address.ciudad,
        address.estado,
      ];
      domicilio = infos.join(", ");
    }

    /**
     * ordenParcialidades
     */
    if (item.ordenParcialidades == null) {
      toast.error(
        "La Orden de Venta debe estar en Bodega Surtido para poder imprimir.",
      );
      return;
    }

    const totalPrimerAbono =
      item.ordenParcialidades.productoParcialidades.reduce(
        (accumulator, productoParcial) => {
          const sum = productoParcial.parcialidades[0].total;
          return accumulator + sum;
        },
        0,
      );

    const ordenParcialidades = {
      totalPrimerAbono: Singleton.getInstance().format(totalPrimerAbono),
      fechaInicio: format(
        item.ordenParcialidades.fechaInicio,
        "dd 'de' MMMM 'de' yyyy",
      ),
      fechaFin: format(item.ordenParcialidades.fechaFin, "MMMM 'de' yyyy"),
      totalParcialidades: item.ordenParcialidades.totalParcialidades,
    };

    if (clienteName == null || clienteName.length === 0) {
      clienteName = asociadoName;
    }

    /*
    id 27 es asociado SITIO PAGONI
    */
    const SITIO_PAGONI_ID = 27;

    const showParcialidades = item.asociado === SITIO_PAGONI_ID;
    const showPagare = item.asociado === SITIO_PAGONI_ID;

    //--
    const payload = {
      fecha: ordenDate,
      asociado: asociadoName,
      cliente: clienteName,
      domicilio: domicilio,
      folio: item.id,
      productos: detalles,
      total: total,
      subTotal: subTotal,
      bonificacion: descuento,
      totalDesc: totalLetra,
      plazos: ordenParcialidades,
      showParcialidades: showParcialidades,
      showPagare: showPagare,
    };

    const responseProductos = await api.printTicket(payload).catch((e) => {
      toast.error("Error al imprimir ticket Orden de Venta.");
    });
    if (!responseProductos) return;
  }

  function configAddress(item, index) {
    let newItem = {
      id: 0,
      ordenVentaId: item.id,
    };
    if (item.entregasForaneas?.length > 0) {
      newItem = item.entregasForaneas[0];
    }

    newItem.ordenVentaId = item.id;

    loadItem(newItem);
  }

  function loadItem(item) {
    setModalData(item);
    createProductoRef.current.toggleModal();
  }

  function openCancel(event, data) {
    setModalDataCancel(data);
    cancelOrdenVentaRef.current.toggleModal();
  }

  function openDevolucion(event, data) {
    setModalDataDevolucion(data);
    devolucionOrdenRef.current.toggleModal();
  }

  function optionsEstatusOrdenVenta(estatusOrden) {
    /*
    const ORDEN_VENTA_STATES = { COMPLETADO id
    */
    const isEnProcesoChecked =
      estatusOrden.id === ORDEN_VENTA_STATUS.EN_PROCESO.id;
    //  const isCanceladoChecked =
    //  estatusOrden.id === ORDEN_VENTA_STATUS.CANCELADO.id;
    const isCompletadoChecked =
      estatusOrden.id === ORDEN_VENTA_STATUS.COMPLETADO.id;
    //  const isDevolucionChecked =
    //estatusOrden.id === ORDEN_VENTA_STATUS.DEVOLUCION.id;

    const completadoOption = {
      name: "Completado",
      id: ORDEN_VENTA_STATUS.COMPLETADO.id,
      checked: isCompletadoChecked,
    };

    let options = [];
    //if (isEnProcesoChecked) {
    options.push(completadoOption);
    //}

    return options;
  }

  function optionsForBodega(estadoBodega) {
    const isApartadoChecked = estadoBodega.id === EstadoBodega.Apartado;
    const isEnProcesoChecked = estadoBodega.id === EstadoBodega.EnProceso;

    let options = [];
    if (isEnProcesoChecked) {
      options.push({
        name: "Apartado",
        id: EstadoBodega.Apartado,
        checked: isApartadoChecked,
      });
      options.push({
        name: "Surtido",
        id: EstadoBodega.Surtido,
        checked: isApartadoChecked,
      });
    } else if (isApartadoChecked) {
      options.push({
        name: "En Proceso",
        id: EstadoBodega.EnProceso,
        checked: isEnProcesoChecked,
      });
      options.push({
        name: "Surtido",
        id: EstadoBodega.Surtido,
        checked: isApartadoChecked,
      });
    }

    return options;
  }

  function optionsForEstadoOrden(estadoOrden) {
    const isEnProcesoChecked = estadoOrden.id === EstadoOrden.EnProceso;
    const isListoParaRecogerChecked =
      estadoOrden.id === EstadoOrden.ListoParaRecoger;
    const isListoParaEntregaChecked =
      estadoOrden.id === EstadoOrden.ListoParaEntrega;
    const isCompletadoChecked = estadoOrden.id === EstadoOrden.Completado;

    const listoParaRecogerOption = {
      name: "Listo Para Recoger",
      id: EstadoOrden.ListoParaRecoger,
      checked: isListoParaRecogerChecked,
    };

    const listoParaEntregarOption = {
      name: "Listo Para Entrega",
      id: EstadoOrden.ListoParaEntrega,
      checked: isListoParaEntregaChecked,
    };

    const completadoOption = {
      name: "Completado",
      id: EstadoOrden.Completado,
      checked: isCompletadoChecked,
    };

    let options = [];
    if (isEnProcesoChecked) {
      options.push(listoParaRecogerOption);
      options.push(listoParaEntregarOption);
      options.push(completadoOption);
    } else if (isListoParaRecogerChecked) {
      options.push(listoParaEntregarOption);
      options.push(completadoOption);
    } else if (isListoParaEntregaChecked) {
      options.push(listoParaRecogerOption);
      options.push(completadoOption);
    }

    return options;
  }

  return (
    <>
      <CancelOrdenVentaModal
        ref={cancelOrdenVentaRef}
        item={modalDataCancel}
        reload={reloadOrdenes}
      />

      <DevolucionOrdenVentaModal
        ref={devolucionOrdenRef}
        item={modalDataDevolucion}
        reload={reloadOrdenes}
      />

      <table
        className="table table-borderless datable sortable table-hover"
        style={{}}
      >
        <thead
          className="table-light"
          style={{ verticalAlign: "middle", textAlign: "center" }}
        >
          <tr ref={theadRef}>
            <th
              scope="col"
              data-column="id"
              style={{ width: "50px" }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>
            <th
              scope="col"
              data-column="cliente.id"
              onClick={(event) => handleSort(event)}
            >
              Cliente
            </th>
            <th
              scope="col"
              data-column="asociado.id"
              className="no-sort"
              onClick={(event) => handleSort(event)}
            >
              Asociado
            </th>
            <th
              scope="col"
              data-column="fechaOrden"
              className="no-sort"
              style={{ width: "170px" }}
              onClick={(event) => handleSort(event)}
            >
              Fecha Orden
            </th>

            <th
              scope="col"
              data-column="estadoBodega"
              style={{ width: "150px" }}
              onClick={(event) => handleSort(event)}
            >
              Bodega
            </th>
            <th
              scope="col"
              data-column="fechaSurtido"
              style={{ width: "150px" }}
              onClick={(event) => handleSort(event)}
            >
              Fecha Surtido
            </th>

            <th
              scope="col"
              data-column="estatuOrden"
              style={{ width: "80px" }}
              onClick={(event) => handleSort(event)}
            >
              Estado
            </th>
            <th
              scope="col"
              data-column="tipoEntrega"
              style={{ width: "90px" }}
              onClick={(event) => handleSort(event)}
            >
              Entrega
            </th>
            <th
              scope="col"
              data-column="fechaEntrega"
              style={{
                width: "170px",
                verticalAlign: "middle",
                justifyItems: "center",
                textAlign: "center",
              }}
              onClick={(event) => handleSort(event)}
            >
              Fecha Entrega
            </th>
            <th
              scope="col"
              data-column="estatuOrden"
              style={{ width: "80px" }}
              onClick={(event) => handleSort(event)}
            >
              Estatus
            </th>
            <th scope="col" className="no-sort" style={{ width: "80px" }}>
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={11} rowCount={10} />}

          {!isLoading &&
            items?.length > 0 &&
            items?.map((item, index) => {
              const ordenDate = format(item.fechaOrden, "dd/MM/yy hh:mm a");
              const ordenfechaSurtidoDate =
                item.fechaSurtido?.length > 0
                  ? format(item.fechaSurtido, "dd/MM/yy hh:mm a")
                  : "";
              const fechaEntregaDate = item.fechaEntrega
                ? format(item.fechaEntrega, "dd/MM/yy hh:mm a")
                : "-";

              const optionsBodega = optionsForBodega(item.estadoBodega);

              const optionsEstadoOrden = optionsForEstadoOrden(
                item.estadoOrden,
              );

              const optionsEstatuOrden = optionsEstatusOrdenVenta(
                item.estatuOrden,
              );

              const canPrint = !(item.estadoBodega.id === EstadoBodega.Surtido);
              const canEditForaneo =
                item.tipoEntrega.id === TipoEntrega.Foranea;

              const infoCliente = item.cliente ?? item.asociado;

              const canShowSelectBodegaOption =
                EstadoBodega.Surtido !== item.estadoBodega.id;

              const aStyle = handleTipoEntrega(item.tipoEntrega.id).style;

              let canCancelar = false; //optionsEstatuOrden?.length > 0;
              //if (item?.estatuOrden?.id !== ORDEN_VENTA_STATUS.CANCELADO.id) {
              if (
                item?.estatuOrden?.id === ORDEN_VENTA_STATUS.EN_PROCESO.id ||
                item?.estatuOrden?.id === ORDEN_VENTA_STATUS.COMPLETADO.id
              ) {
                if (isAdmin) {
                  canCancelar = true;
                } else {
                  canCancelar = permissions.canCancelar;
                  if (item?.fechaEntrega) {
                    const PASSDAYS = 5;
                    const fechaEntrega = parseJSON(item?.fechaEntrega);
                    canCancelar = !hasDatePassedXDays(fechaEntrega, PASSDAYS);
                  }
                }
              }

              //if(!isAdmin && optionsEstatuOrden?.length > 0 )

              let canDevolver = false;
              if (item?.fechaEntrega != null) {
                const PASS3DAYS = 15;

                const fechaEntrega = parseJSON(item?.fechaEntrega);
                canDevolver =
                  item?.estatuOrden?.id === ORDEN_VENTA_STATUS.COMPLETADO.id &&
                  !hasDatePassedXDays(fechaEntrega, PASS3DAYS);

                canDevolver = isAdmin;
              }

              return (
                <tr key={item.id}>
                  <th scope="row" style={{ verticalAlign: "middle" }}>
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.id}
                    </a>
                  </th>
                  <td>{buildName(infoCliente, infoCliente?.id)}</td>
                  <td>{buildName(item.asociado, item.asociado?.id)}</td>
                  <td>{ordenDate}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        columnGap: "5px",
                      }}
                    >
                      <div className="">
                        <span
                          className={`badge bg-${handleEstadoBodega(
                            item.estadoBodega.id,
                          )}`}
                          style={{ width: "75px" }}
                        >
                          {item.estadoBodega?.nombre ?? ""}
                        </span>
                      </div>

                      {canShowSelectBodegaOption && (
                        <div className="">
                          <span>
                            <ComboButton
                              options={optionsBodega}
                              onSelectionChange={(option) =>
                                changeBodegaStatus(item.id, option)
                              }
                            />
                          </span>
                        </div>
                      )}
                    </div>
                  </td>
                  <td>{ordenfechaSurtidoDate}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        columnGap: "5px",
                      }}
                    >
                      <div className="">
                        <span
                          className={`badge ${
                            handleOrdenVentaEstados(item).class
                          }`}
                        >
                          {item.estadoOrden?.nombre ?? ""}
                        </span>
                      </div>
                      <ComboButton
                        options={optionsEstadoOrden}
                        onSelectionChange={(option) =>
                          changeEstadoOrden(item.id, option)
                        }
                      />
                    </div>
                  </td>

                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: "5px",
                      }}
                    >
                      <div
                        style={{
                          justifyItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className={`badge`}
                          style={{
                            width: "65px",
                            ...aStyle,
                          }}
                        >
                          {item.tipoEntrega?.nombre ?? ""}
                        </span>
                      </div>
                      {canEditForaneo && (
                        <div onClick={(event) => configAddress(item, index)}>
                          <i className="bi bi-three-dots"></i>
                        </div>
                      )}
                    </div>
                  </td>

                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {fechaEntregaDate}
                  </td>

                  <td
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        columnGap: "5px",
                      }}
                    >
                      <div>
                        <span
                          className={`badge ${
                            handleOrdenVentaStatus(item).class
                          }`}
                        >
                          {item.estatuOrden?.nombre ?? ""}
                        </span>
                      </div>
                      <ComboButton
                        options={optionsEstatuOrden}
                        onSelectionChange={(option) =>
                          changeEstatuOrden(item.id, option.id)
                        }
                      />
                    </div>
                  </td>

                  <td>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div class="btn-group" role="group">
                        <button
                          id="btnGroupDrop1"
                          type="button"
                          class="btn btn-primary dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          disabled={canPrint}
                        >
                          <span className={`${styles.tooltiptext}`}>
                            <FaMoneyBillTrendUp />
                          </span>
                        </button>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="btnGroupDrop1"
                        >
                          <li>
                            <button
                              className="dropdown-item"
                              href="#"
                              onClick={(event) => printPDF(event, item)}
                            >
                              Imprimir...
                            </button>
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              href="#"
                              onClick={(event) => generatePDF(event, item)}
                            >
                              Descargar PDF...
                            </a>
                          </li>
                        </ul>
                      </div>

                      {canCancelar && (
                        <button
                          className={`btn btn-danger ${styles.tooltip}`}
                          onClick={(event) => openCancel(event, item)}
                        >
                          <div>
                            <span className={`${styles.tooltiptext}`}>
                              Solicitar Cancelar Orden
                            </span>
                            <MdMoveUp />
                          </div>
                        </button>
                      )}
                      {canDevolver && (
                        <button
                          className={`btn btn-own-purple ${styles.tooltip}`}
                          onClick={(event) => openDevolucion(event, item)}
                        >
                          <div>
                            <span className={`${styles.tooltiptext}`}>
                              Solicitar Devolución Orden
                            </span>
                            <MdMoveUp />
                          </div>
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {message && <p className="mx-alert-info">{message}</p>}
      {base64 && (
        <iframe
          title="thix"
          src={`data:application/pdf;base64,${base64}`}
          className="mx-iframe"
        />
      )}
      <div id="yourContainerId" />

      <ConfigForaneo
        ref={createProductoRef}
        item={modalData}
        reloadOrdenes={reloadOrdenes}
      />
    </>
  );
}
